import { useRef, useState } from 'react';

// 支持的语言列表
const languageList = [
  {
    id: 0,
    name: 'English',
    language: 'English',
  },
  {
    id: 1,
    name: 'French',
    language: 'Français',
  },
  {
    id: 2,
    name: 'Spanish',
    language: 'Español',
  },
  {
    id: 3,
    name: 'Portuguese',
    language: 'Português',
  },
  {
    id: 4,
    name: 'German',
    language: 'Deutsch',
  },
  {
    id: 5,
    name: 'Arabic',
    language: 'العربية',
  },
  // {
  //   id: 6,
  //   name: 'Hindi',
  //   language: 'हिन्दी',
  // },
  {
    id: 7,
    name: 'Italian',
    language: 'Italiano',
  },
  {
    id: 8,
    name: 'Dutch',
    language: 'Nederlands',
  },
  // {
  //   id: 9,
  //   name: 'Danish',
  //   language: 'Dansk',
  // },
  // {
  //   id: 10,
  //   name: 'Finnish',
  //   language: 'Suomi',
  // },
  // {
  //   id: 11,
  //   name: 'Swedish',
  //   language: 'Svenska',
  // },
  {
    id: 12,
    name: 'Polish',
    language: 'Polski',
  },
  {
    id: 13,
    name: 'Russian',
    language: 'Русский',
  },
  {
    id: 14,
    name: 'Japanese',
    language: '日本語',
  },
  {
    id: 15,
    name: 'Chinese',
    language: '中文',
  },
  {
    id: 16,
    name: 'Korean',
    language: '한국어',
  },
  // {
  //   id: 17,
  //   name: 'Malay',
  //   language: 'Bahasa Melayu',
  // },
  // {
  //   id: 18,
  //   name: 'Filipino',
  //   language: 'Filipino',
  // },
  // {
  //   id: 19,
  //   name: 'Indonesian',
  //   language: 'Bahasa Indonesia',
  // },
];

// 目标的语言列表
const targetLanguageList = [
  {
    id: 0,
    name: 'English',
    language: 'English',
  },
  {
    id: 1,
    name: 'French',
    language: 'Français',
  },
  {
    id: 2,
    name: 'Spanish',
    language: 'Español',
  },
  {
    id: 4,
    name: 'German',
    language: 'Deutsch',
  },
  {
    id: 5,
    name: 'Arabic',
    language: 'العربية',
  },
  {
    id: 14,
    name: 'Japanese',
    language: '日本語',
  },
  {
    id: 15,
    name: 'Chinese',
    language: '中文',
  },
  {
    id: 16,
    name: 'Korean',
    language: '한국어',
  },
  {
    id: 17,
    name: 'Russian',
    language: 'Русский',
  },
  {
    id: 18,
    name: 'Dutch',
    language: 'Nederlands',
  },
  {
    id: 19,
    name: 'Italian',
    language: 'Italiano',
  },
  {
    id: 20,
    name: 'Polish',
    language: 'Polski',
  },
  {
    id: 21,
    name: 'Portuguese',
    language: 'Português',
  },
];

// 添加字幕项目原始语言额外支持的语种
const languageList_subtitle = [
  {
    id: 0,
    name: 'English',
    language: 'English',
  },
  {
    id: 1,
    name: 'Chinese',
    language: '中文',
  },
  {
    id: 2,
    name: 'Spanish',
    language: 'Español',
  },
  {
    id: 3,
    name: 'Arabic',
    language: 'العربية',
  },
  {
    id: 4,
    name: 'Hindi',
    language: 'हिन्दी',
  },
  {
    id: 5,
    name: 'Portuguese',
    language: 'Português',
  },
  {
    id: 6,
    name: 'Bengali',
    language: 'বাংলা',
  },
  {
    id: 7,
    name: 'Russian',
    language: 'Русский',
  },
  {
    id: 8,
    name: 'Indonesian',
    language: 'Bahasa Indonesia',
  },
  {
    id: 9,
    name: 'French',
    language: 'Français',
  },
  {
    id: 10,
    name: 'Japanese',
    language: '日本語',
  },
  {
    id: 11,
    name: 'German',
    language: 'Deutsch',
  },
  {
    id: 12,
    name: 'Korean',
    language: '한국어',
  },
  {
    id: 13,
    name: 'Tagalog',
    language: 'Tagalog',
  },
  {
    id: 14,
    name: 'Telugu',
    language: 'తెలుగు',
  },
  {
    id: 15,
    name: 'Tamil',
    language: 'தமிழ்',
  },
  {
    id: 16,
    name: 'Turkish',
    language: 'Türkçe',
  },
  {
    id: 17,
    name: 'Vietnamese',
    language: 'Tiếng Việt',
  },
  {
    id: 18,
    name: 'Marathi',
    language: 'मराठी',
  },
  {
    id: 19,
    name: 'Malayalam',
    language: 'മലയാളം',
  },
  {
    id: 20,
    name: 'Gujarati',
    language: 'ગુજરાતી',
  },
  {
    id: 21,
    name: 'Farsi',
    language: 'فارسی',
  },
  {
    id: 22,
    name: 'Malay',
    language: 'Bahasa Melayu',
  },
  {
    id: 23,
    name: 'Hausa',
    language: 'Hausa',
  },
  {
    id: 24,
    name: 'Punjabi',
    language: 'ਪੰਜਾਬੀ',
  },
  {
    id: 25,
    name: 'Swahili',
    language: 'Kiswahili',
  },
  {
    id: 26,
    name: 'Polish',
    language: 'Polski',
  },
  {
    id: 27,
    name: 'Romanian',
    language: 'Română',
  },
  // {
  //   id: 28,
  //   name: 'Tagalog',
  //   language: 'Tagalog',
  // },
  {
    id: 29,
    name: 'Chinese, Cantonese',
    language: '廣東話',
  },
  {
    id: 30,
    name: 'Slovak',
    language: 'Slovenčina',
  },
  {
    id: 31,
    name: 'Dutch',
    language: 'Nederlands',
  },
  {
    id: 32,
    name: 'Italian',
    language: 'Italiano',
  },
  {
    id: 33,
    name: 'Swedish',
    language: 'Svenska',
  },
  {
    id: 34,
    name: 'Norwegian',
    language: 'Norsk',
  },
  {
    id: 35,
    name: 'Czech',
    language: 'Čeština',
  },
  {
    id: 36,
    name: 'Hungarian',
    language: 'Magyar',
  },
  {
    id: 37,
    name: 'Finnish',
    language: 'Suomi',
  },
  {
    id: 38,
    name: 'Danish',
    language: 'Dansk',
  },
  {
    id: 39,
    name: 'Estonian',
    language: 'Eesti',
  },
  {
    id: 40,
    name: 'Lithuanian',
    language: 'Lietuvių',
  },
  {
    id: 41,
    name: 'Latvian',
    language: 'Latviešu',
  },
  {
    id: 42,
    name: 'Icelandic',
    language: 'Íslenska',
  },
  {
    id: 43,
    name: 'Catalan',
    language: 'Català',
  },
  {
    id: 44,
    name: 'Croatian',
    language: 'Hrvatski',
  },
  {
    id: 45,
    name: 'Serbian',
    language: 'Српски',
  },
  {
    id: 46,
    name: 'Bulgarian',
    language: 'Български',
  },
  {
    id: 47,
    name: 'Hebrew',
    language: 'עברית',
  },
  {
    id: 48,
    name: 'Greek',
    language: 'Ελληνικά',
  },
  {
    id: 49,
    name: 'Azerbaijani',
    language: 'Azərbaycanca',
  },
  {
    id: 50,
    name: 'Uzbek',
    language: 'O‘zbek',
  },
  {
    id: 51,
    name: 'Tatar',
    language: 'Татарча',
  },
  {
    id: 52,
    name: 'Zulu',
    language: 'isiZulu',
  },
  {
    id: 53,
    name: 'Sinhala',
    language: 'සිංහල',
  },
  {
    id: 54,
    name: 'Kazakh',
    language: 'Қазақ тілі',
  },
  {
    id: 55,
    name: 'Mongolian',
    language: 'Монгол',
  },
  {
    id: 56,
    name: 'Pashto',
    language: 'پښتو',
  },
  {
    id: 57,
    name: 'Somali',
    language: 'Af Soomaali',
  },
  {
    id: 58,
    name: 'Welsh',
    language: 'Cymraeg',
  },
  {
    id: 59,
    name: 'Wolof',
    language: 'Wolof',
  },
  {
    id: 60,
    name: 'Armenian',
    language: 'Հայերեն',
  },
  {
    id: 61,
    name: 'Afrikaans',
    language: 'Afrikaans',
  },
  {
    id: 62,
    name: 'Slovenian',
    language: 'Slovenščina',
  },
  {
    id: 63,
    name: 'Abkhaz',
    language: 'Аҧсуа',
  },
  {
    id: 64,
    name: 'Arabic, Gulf',
    language: 'الخليجية',
  },
  {
    id: 65,
    name: 'Asturian',
    language: 'Asturianu',
  },
  {
    id: 66,
    name: 'Bashkir',
    language: 'Башҡорт теле',
  },
  {
    id: 67,
    name: 'Basque',
    language: 'Euskara',
  },
  {
    id: 68,
    name: 'Belarusian',
    language: 'Беларуская',
  },
  {
    id: 69,
    name: 'Bosnian',
    language: 'Bosanski',
  },
  {
    id: 70,
    name: 'Central Kurdish, Iran',
    language: 'کوردیی ناوەندی (ئێران)',
  },
  {
    id: 71,
    name: 'Central Kurdish, Iraq',
    language: 'کوردیی ناوەندی (عێراق)',
  },
  {
    id: 72,
    name: 'Chinese, Traditional',
    language: '繁體中文',
  },
  {
    id: 73,
    name: 'English, Australian',
    language: 'Australian English',
  },
  {
    id: 74,
    name: 'English, British',
    language: 'British English',
  },
  {
    id: 75,
    name: 'English, Indian',
    language: 'Indian English',
  },
  {
    id: 76,
    name: 'English, Irish',
    language: 'Irish English',
  },
  {
    id: 77,
    name: 'English, New Zealand',
    language: 'New Zealand English',
  },
  {
    id: 78,
    name: 'English, Scottish',
    language: 'Scottish English',
  },
  {
    id: 79,
    name: 'English, South African',
    language: 'South African English',
  },
  {
    id: 80,
    name: 'English, US',
    language: 'American English',
  },
  {
    id: 81,
    name: 'English, Welsh',
    language: 'Welsh English',
  },
  {
    id: 82,
    name: 'French, Canadian',
    language: 'Français canadien',
  },
  {
    id: 83,
    name: 'Galician',
    language: 'Galego',
  },
  {
    id: 84,
    name: 'Georgian',
    language: 'ქართული',
  },
  {
    id: 85,
    name: 'German, Swiss',
    language: 'Schweizerdeutsch',
  },
  {
    id: 86,
    name: 'Kabyle',
    language: 'Taqbaylit',
  },
  {
    id: 87,
    name: 'Kannada',
    language: 'ಕನ್ನಡ',
  },
  {
    id: 88,
    name: 'Kinyarwanda',
    language: 'Kinyarwanda',
  },
  {
    id: 89,
    name: 'Kyrgyz',
    language: 'Кыргызча',
  },
  {
    id: 90,
    name: 'Luganda',
    language: 'Luganda',
  },
  {
    id: 91,
    name: 'Macedonian',
    language: 'Македонски',
  },
  {
    id: 92,
    name: 'Maltese',
    language: 'Malti',
  },
  {
    id: 93,
    name: 'Meadow Mari',
    language: 'Олык марий',
  },
  {
    id: 94,
    name: 'oria',
    language: 'ଓଡ଼ିଆ',
  },
  {
    id: 95,
    name: 'Portuguese, Brazilian',
    language: 'Português brasileiro',
  },
  {
    id: 96,
    name: 'Spanish, US',
    language: 'Español (EE.UU.)',
  },
  {
    id: 97,
    name: 'Sundanese',
    language: 'Basa Sunda',
  },
  {
    id: 98,
    name: 'Swahili, Kenya',
    language: 'Kiswahili (Kenya)',
  },
  {
    id: 99,
    name: 'Swahili, Burundi',
    language: 'Kiswahili (Burundi)',
  },
  {
    id: 100,
    name: 'Swahili, Rwanda',
    language: 'Kiswahili (Rwanda)',
  },
  {
    id: 101,
    name: 'Swahili, Tanzania',
    language: 'Kiswahili (Tanzania)',
  },
  {
    id: 102,
    name: 'Swahili, Uganda',
    language: 'Kiswahili (Uganda)',
  },
  {
    id: 103,
    name: 'Thai',
    language: 'ไทย',
  },
  {
    id: 104,
    name: 'Ukrainian',
    language: 'Українська',
  },
  {
    id: 105,
    name: 'Uyghur',
    language: 'ئۇيغۇرچە',
  },
];
// 添加字幕项目目标语言额外支持的语种
const targetLanguageList_subtitle = [
  {
    id: 0,
    name: 'English',
    language: 'English',
  },
  {
    id: 1,
    name: 'Chinese',
    language: '中文',
  },
  {
    id: 2,
    name: 'Spanish',
    language: 'Español',
  },
  {
    id: 3,
    name: 'Arabic',
    language: 'العربية',
  },
  {
    id: 4,
    name: 'Hindi',
    language: 'हिन्दी',
  },
  {
    id: 5,
    name: 'Portuguese',
    language: 'Português',
  },
  {
    id: 6,
    name: 'Bengali',
    language: 'বাংলা',
  },
  {
    id: 7,
    name: 'Russian',
    language: 'Русский',
  },
  {
    id: 8,
    name: 'Indonesian',
    language: 'Bahasa Indonesia',
  },
  {
    id: 9,
    name: 'French',
    language: 'Français',
  },
  {
    id: 10,
    name: 'Japanese',
    language: '日本語',
  },
  {
    id: 11,
    name: 'German',
    language: 'Deutsch',
  },
  {
    id: 12,
    name: 'Korean',
    language: '한국어',
  },
  {
    id: 13,
    name: 'Tagalog',
    language: 'Tagalog',
  },
  {
    id: 14,
    name: 'Telugu',
    language: 'తెలుగు',
  },
  {
    id: 15,
    name: 'Tamil',
    language: 'தமிழ்',
  },
  {
    id: 16,
    name: 'Turkish',
    language: 'Türkçe',
  },
  {
    id: 17,
    name: 'Vietnamese',
    language: 'Tiếng Việt',
  },
  {
    id: 18,
    name: 'Marathi',
    language: 'मराठी',
  },
  {
    id: 19,
    name: 'Malayalam',
    language: 'മലയാളം',
  },
  {
    id: 20,
    name: 'Gujarati',
    language: 'ગુજરાતી',
  },
  {
    id: 21,
    name: 'Farsi',
    language: 'فارسی',
  },
  {
    id: 22,
    name: 'Malay',
    language: 'Bahasa Melayu',
  },
  {
    id: 23,
    name: 'Hausa',
    language: 'Hausa',
  },
  {
    id: 24,
    name: 'Punjabi',
    language: 'ਪੰਜਾਬੀ',
  },
  {
    id: 25,
    name: 'Swahili',
    language: 'Kiswahili',
  },
  {
    id: 26,
    name: 'Polish',
    language: 'Polski',
  },
  {
    id: 27,
    name: 'Romanian',
    language: 'Română',
  },
  // {
  //   id: 28,
  //   name: 'Tagalog',
  //   language: 'Tagalog',
  // },
  {
    id: 29,
    name: 'Chinese, Cantonese',
    language: '廣東話',
  },
  {
    id: 30,
    name: 'Slovak',
    language: 'Slovenčina',
  },
  {
    id: 31,
    name: 'Dutch',
    language: 'Nederlands',
  },
  {
    id: 32,
    name: 'Italian',
    language: 'Italiano',
  },
  {
    id: 33,
    name: 'Swedish',
    language: 'Svenska',
  },
  {
    id: 34,
    name: 'Norwegian',
    language: 'Norsk',
  },
  {
    id: 35,
    name: 'Czech',
    language: 'Čeština',
  },
  {
    id: 36,
    name: 'Hungarian',
    language: 'Magyar',
  },
  {
    id: 37,
    name: 'Finnish',
    language: 'Suomi',
  },
  {
    id: 38,
    name: 'Danish',
    language: 'Dansk',
  },
  {
    id: 39,
    name: 'Estonian',
    language: 'Eesti',
  },
  {
    id: 40,
    name: 'Lithuanian',
    language: 'Lietuvių',
  },
  {
    id: 41,
    name: 'Latvian',
    language: 'Latviešu',
  },
  {
    id: 42,
    name: 'Icelandic',
    language: 'Íslenska',
  },
  {
    id: 43,
    name: 'Catalan',
    language: 'Català',
  },
  {
    id: 44,
    name: 'Croatian',
    language: 'Hrvatski',
  },
  {
    id: 45,
    name: 'Serbian',
    language: 'Српски',
  },
  {
    id: 46,
    name: 'Bulgarian',
    language: 'Български',
  },
  {
    id: 47,
    name: 'Hebrew',
    language: 'עברית',
  },
  {
    id: 48,
    name: 'Greek',
    language: 'Ελληνικά',
  },
  {
    id: 49,
    name: 'Azerbaijani',
    language: 'Azərbaycanca',
  },
  {
    id: 50,
    name: 'Uzbek',
    language: 'O‘zbek',
  },
  {
    id: 51,
    name: 'Tatar',
    language: 'Татарча',
  },
  {
    id: 52,
    name: 'Zulu',
    language: 'isiZulu',
  },
  {
    id: 53,
    name: 'Sinhala',
    language: 'සිංහල',
  },
  {
    id: 54,
    name: 'Kazakh',
    language: 'Қазақ тілі',
  },
  {
    id: 55,
    name: 'Mongolian',
    language: 'Монгол',
  },
  {
    id: 56,
    name: 'Pashto',
    language: 'پښتو',
  },
  {
    id: 57,
    name: 'Somali',
    language: 'Af Soomaali',
  },
  {
    id: 58,
    name: 'Welsh',
    language: 'Cymraeg',
  },
  {
    id: 59,
    name: 'Wolof',
    language: 'Wolof',
  },
  {
    id: 60,
    name: 'Armenian',
    language: 'Հայերեն',
  },
  {
    id: 61,
    name: 'Afrikaans',
    language: 'Afrikaans',
  },
  {
    id: 62,
    name: 'Slovenian',
    language: 'Slovenščina',
  },
  {
    id: 63,
    name: 'Thai',
    language: 'ไทย',
  },
];
// 人数选项列表
const propleList = [
  {
    id: 0,
    name: 'As_CreateProjectTrans_SpeakerNumAuto',
  },
  {
    id: 1,
    name: '1',
  },
  {
    id: 2,
    name: '2',
  },
  {
    id: 3,
    name: '3',
  },
  {
    id: 4,
    name: '>3',
  },
];

/**
 * 编辑页全局状态管理 hook
 * @returns {Object} 全局状态和更新方法
 */
export const useUploadState = () => {
  // 视频翻译模态框显示状态
  const [vidtranslateModalShow, setVidtranslateModalShow] = useState(false);
  // lips sync开关弹出框
  const [syncModalShow, setSyncModalShow] = useState(false);
  // 用来判断弹窗内显示什么
  // 0:上传，1：youtu，2：准备翻译，3：额度不足
  const [vidtranslateModalType, setVidtranslateModalType] = useState(0);
  // 当前选中翻译方式
  const [tableItem, setTableItem] = useState(0);
  // 是否是字幕
  const [showAddSubtitles, setShowAddSubtitles] = useState(false);
  // 是否使用TTS
  const [ttsState, setTtsState] = useState(false);
  // 是否使用翻译
  const [translateState, setTranslateState] = useState(false);
  // ===== 文件上传相关状态 =====
  // 上传提交加载状态
  const [uploadSubmitLoading, setUploadSubmitLoading] = useState(false);
  // 上传状态 0:未上传 1:上传中 2:上传完成
  const [uploadStatus, setUploadStatus] = useState(0);
  // 上传的文件对象
  const [uploadFile, setUploadFile] = useState(null);
  // 上传实例
  const [vidUploadInstance, setVidUploadInstance] = useState(null);
  // 视频总时长
  const [videoDuration, setVideoDuration] = useState('00:00');
  // 视频消耗时间
  const [videoMinutes, setVideoMinutes] = useState(0);
  // 视频播放地址
  const [playUrl, setPlayUrl] = useState('');
  // 上传进度
  const [progressNum, setProgressNum] = useState(0);
  // 邮箱是否有效
  const [isValidEmail, setIsValidEmail] = useState(true);
  // 源语言
  const [sourceLanguage, setSourceLanguage] = useState(languageList[0]);
  // 目标语言
  const [targetLanguage, setTargetLanguage] = useState(languageList[1]);
  // 人数
  const [peopleCount, setPeopleCount] = useState(propleList[0]);
  // 是否添加字幕
  const [captionsFlag, setCaptionsFlag] = useState(false);
  // 是否同步
  const [syncFlag, setSyncFlag] = useState(false);
  const [generateSpeech, setGenerateSpeech] = useState(false);
  // 上传URL
  const [uploadUrl, setUploadUrl] = useState('');
  const [uploadMessage, setUploadMessage] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);

  // ===== youto视频URL相关状态 =====
  // youto提交加载状态
  const [pasteSubmitLoading, setPasteSubmitLoading] = useState(false);
  // youto的视频URL
  const [pasteVideoUrl, setPasteVideoUrl] = useState('');
  // URL是否有效
  const [isValidVideoUrl, setIsValidVideoUrl] = useState(true);
  // youto模式下的邮箱
  const [pasteEmail, setPasteEmail] = useState('');
  // youto模式下邮箱是否有效
  const [isPasteValidEmail, setIsPasteValidEmail] = useState(true);
  // youto模式下的源语言
  const [pastesourceLanguage, setPasteSourceLanguage] = useState(languageList[0]);
  // youto模式下的目标语言
  const [pastetargetLanguage, setPasteTargetLanguage] = useState(languageList[1]);
  // youto模式下的人数
  const [pastePeopleCount, setPastePeopleCount] = useState(propleList[0]);
  // 视频总时长
  const [pasteVideoDuration, setPasteVideoDuration] = useState('00:00');
  // 视频消耗时间
  const [pasteVideoMinutes, setPasteVideoMinutes] = useState(0);
  // youto模式下是否添加字幕
  const [pastecaptionsFlag, setPasteCaptionsFlag] = useState(false);
  // youto模式下是否同步
  const [pastesyncFlag, sePastetSyncFlag] = useState(false);
  const [pasteGenerateSpeech, setPasteGenerateSpeech] = useState(false);

  const [youtoMessage, setYoutoMessage] = useState('');

  // ===== 提交相关状态 =====
  // 提交模态框显示状态
  const [submitModalShow, setSubmitModalShow] = useState(false);
  // 提交类型 upload/paste
  const [submitType, setSubmitType] = useState('upload');
  // 提交模态框状态 submit/success/error
  const [submitModalStatus, setSubmitModalStatus] = useState('submit');
  // YouTube视频详情
  const [youtoDetail, setYoutoDetail] = useState({});
  // 非YouTube URL提示显示状态
  const [notYoutoUrlShow, setNotYoutoUrlShow] = useState(false);
  // 上传的数据
  const [uploadData, setUploadData] = useState({});
  // 封面图片
  const [coverUploaderImg, setCoverUploaderImg] = useState({});
  const fileVideoTime = useRef(0);
  const urlVideoTime = useRef(0);
  const popUpClose = useRef(false);

  /**
   * 清空所有状态数据
   */
  const clearData = () => {
    setVidtranslateModalType(0);
    setTableItem(0);

    // ===== upload =====
    setUploadSubmitLoading(false);
    setUploadStatus(0);
    setUploadFile(null);
    setVideoDuration('00:00');
    setVideoMinutes(0);
    setPlayUrl('');
    setProgressNum(0);
    setSourceLanguage(languageList[0]);
    setTargetLanguage(languageList[1]);
    setPeopleCount(propleList[0]);
    setCaptionsFlag(false);
    setSyncFlag(false);
    setGenerateSpeech(false);
    setUploadUrl('');

    // ===== youto =====
    setPasteVideoUrl('');
    setIsValidVideoUrl(true);
    setPasteSourceLanguage(languageList[0]);
    setPasteTargetLanguage(languageList[1]);
    setPastePeopleCount(propleList[0]);
    setPasteCaptionsFlag(false);
    sePastetSyncFlag(false);
    setPasteVideoDuration('00:00');
    setPasteVideoMinutes(0);

    setSubmitModalShow(false);
    setSubmitType('upload');
    setSubmitModalStatus('submit');
    setYoutoDetail({});
    setNotYoutoUrlShow(false);
    setPasteGenerateSpeech(false);

    setUploadData({});
    setCoverUploaderImg({});
    setYoutoMessage('');
    setUploadMessage('');

    fileVideoTime.current = 0;
    urlVideoTime.current = 0;
    popUpClose.current = false;
  };
  const setDefaultLanguage = (defaultLanguage) => {
    if (!defaultLanguage) return;
    const languageCode = localStorage.getItem('i18nextLng') || 'en-US';
    const { originalLanguage, bilingualLanguage } = defaultLanguage.find((res) =>
      res.code.includes(languageCode),
    );
    const origina = showAddSubtitles
      ? targetLanguageList_subtitle.find((res) => res.name === originalLanguage)
      : languageList.find((res) => res.name === originalLanguage);
    const bilingual = showAddSubtitles
      ? targetLanguageList_subtitle.find((res) => res.name === bilingualLanguage)
      : targetLanguageList.find((res) => res.name === bilingualLanguage);
    if (origina) {
      setSourceLanguage(origina);
      setPasteSourceLanguage(origina);
    }
    if (bilingual) {
      setTargetLanguage(bilingual);
      setPasteTargetLanguage(bilingual);
    }
  };
  // 返回所有状态和更新方法
  return {
    targetLanguageList,
    vidtranslateModalShow,
    setVidtranslateModalShow,
    clearData,
    tableItem,
    setTableItem,
    uploadStatus,
    setUploadStatus,
    uploadFile,
    setUploadFile,
    playUrl,
    setPlayUrl,
    isValidEmail,
    setIsValidEmail,
    sourceLanguage,
    setSourceLanguage,
    targetLanguage,
    setTargetLanguage,
    peopleCount,
    setPeopleCount,
    captionsFlag,
    setCaptionsFlag,
    syncFlag,
    setSyncFlag,
    languageList,
    propleList,
    pasteEmail,
    setPasteEmail,
    isPasteValidEmail,
    setIsPasteValidEmail,
    pastesourceLanguage,
    setPasteSourceLanguage,
    pastetargetLanguage,
    setPasteTargetLanguage,
    pastePeopleCount,
    setPastePeopleCount,
    pastecaptionsFlag,
    setPasteCaptionsFlag,
    pastesyncFlag,
    sePastetSyncFlag,
    pasteVideoUrl,
    setPasteVideoUrl,
    isValidVideoUrl,
    setIsValidVideoUrl,
    progressNum,
    setProgressNum,
    uploadUrl,
    setUploadUrl,
    uploadSubmitLoading,
    setUploadSubmitLoading,
    pasteSubmitLoading,
    setPasteSubmitLoading,
    submitModalShow,
    setSubmitModalShow,
    submitModalStatus,
    setSubmitModalStatus,
    notYoutoUrlShow,
    setNotYoutoUrlShow,
    submitType,
    setSubmitType,
    youtoDetail,
    setYoutoDetail,
    uploadData,
    setUploadData,
    coverUploaderImg,
    setCoverUploaderImg,
    vidtranslateModalType,
    setVidtranslateModalType,
    videoDuration,
    setVideoDuration,
    videoMinutes,
    setVideoMinutes,
    vidUploadInstance,
    setVidUploadInstance,
    pasteVideoDuration,
    setPasteVideoDuration,
    pasteVideoMinutes,
    setPasteVideoMinutes,
    youtoMessage,
    setYoutoMessage,
    uploadMessage,
    setUploadMessage,
    syncModalShow,
    setSyncModalShow,
    pasteGenerateSpeech,
    setPasteGenerateSpeech,
    generateSpeech,
    setGenerateSpeech,
    submitLoading,
    setSubmitLoading,
    showAddSubtitles,
    setShowAddSubtitles,
    ttsState,
    setTtsState,
    translateState,
    setTranslateState,
    fileVideoTime,
    urlVideoTime,
    targetLanguageList_subtitle,
    languageList_subtitle,
    setDefaultLanguage,
    popUpClose,
  };
};
